import QuizierComponent from './components/quizier';
import FBComments from './components/FBComments';
import store from './store';
import ComponentMixin from './mixins';

const quizier = {};
const quizierOptions = {
    defaultLanguage: '',
    languages: [],
    blocks: [],
    settings: [],
    quizierEvent: {
        onInit: () => {},
    },
    post: false
};

quizier.install = (Vue, optionsOut) => {
    const options = Object.assign({}, quizierOptions, optionsOut);
    options.quizierEvent = Object.assign({},
        quizierOptions.quizierEvent,
        optionsOut.quizierEvent,
    );

    if (!options.languages || !options.languages.length) {
        throw new Error('languages is not set ');
    }

    if (!options.defaultLanguage) {
        throw new Error('defaultLanguage is not set..');
    }

    if (!options.post) {
        throw new Error('post not found');
    }

    Vue.component('quizier-viewer', QuizierComponent);
    Vue.component('fb-comment', FBComments);

    /*
     * Register component initilaze
     * @TODO : Validate template for existing ?????
     */
    store.init('languages', options.languages);
    store.init('notifications', {});
    store.init('post_id', options.post);

    /*
     * İnit blocks
     */
    if (options.blocks) {
        // options.blocks =
        // let blocks = options.blocks.sort(store.compare);
        store.init('blocks', options.blocks);
    }

    /*
     * İnit preview
     */
    if (options.isPreview) {
        store.init('isPreview', options.isPreview);
    }

    /*
     * İnit blocks
     */
    if (options.settings) {
        store.init('settings', options.settings);
    }

    /*
     * Init Custom components
     */
    const _modules = Object.assign([], options.modules);

    const mList = _modules.map(m => {
        m.contents = m.contents || {};
        store.state.languages.map(l => {
            m.contents[l] = {};
            m.contents[l].data = {};

            return true;
        });

        Vue.component(m.name, Object.assign({}, m.context));
        delete m.context;
        return m;
    });

    const s = store.state.settings;
    s.data = s.data || {};
    store.state.languages.map(l => {
        s.data[l] = s.data[l] || {};
    });


    store.init("moduleList", mList);
    store.init("currentLanguge", options.defaultLanguage);
    Vue.prototype.$quizierEvent = options.quizierEvent;
};


export {
    quizier
};
export {
    ComponentMixin
};
